import firestore from './firestoreService'

const COLL = 'users'

export const usersService = {
  subscribeUsers: (cb, onError) =>
    firestore.subscribe(COLL, {}, cb, onError),

  getUserProfile: (uid) => firestore.getById(COLL, uid),

  createUserDoc: (uid, data) =>
    firestore.set(COLL, uid, { ...data, createdAt: firestore.timestamp() }),

  updateUser: (id, patch) => firestore.update(COLL, id, patch),
  deleteUser: (id) => firestore.remove(COLL, id),
}

export default usersService
